<template>
    <div id="echart-rose" :style="{ height: '100%',width:'100%'}"></div>   
</template>

<script>
export default({
    props:{
        type:String,
    },
    data(){
        return{
            option:null
        }
    },
    methods: {
        initData() {

        },
        initChart() {  
            this.barCirChart = this.echarts.init(document.getElementById("echart-rose"));
            const optionMetabolite = {
                legend: {
                    top: 'bottom',
                    left:"10%"
                },
                tooltip: {
                    trigger: 'item',
                    formatter:function(p){
                            if (!p.value && p.value !== 0) return 0;
                            let str = p.value.toString();
                            let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
                            return p.name+" : "+str.replace(reg, "$1,")+" ("+p.percent+"%)";
                        },
                },
                title: [
                    {
                        text: 'Categories',
                        left: '10%',
                        top: '0%',
                        textAlign: 'left',
                        textStyle: {
                            "fontSize": 15
                        }
                    },
                    // {
                    //     text: 'Down',
                    //     left: '70%',
                    //     top: '0%',
                    //     textAlign: 'center',
                    //     textStyle: {
                    //         "fontSize": 15
                    //     }
                    // },
                ],
                series: [
                {
                    type: 'pie',
                    radius: [30,80],
                    center: ['50%', '22%'],
                    // roseType: 'area',
                    itemStyle: {
                        borderRadius: 8,
                            color: function (params) {
                                // build a color map as your need.
                                var colorList = [
                                    'rgb(200,150,255)','rgb(240,151,0)','rgb(251,241,123)','rgb(130,204,232)','rgb(167,213,193)',
                                    'rgb(255,205,67)','rgb(72,157,240)','rgb(238,102,102)','rgb(221,235,164)','rgb(252,132,82)',
                                    'rgb(244,136,184)','rgb(10,185,155)','rgb(239,89,160)','rgb(242,204,185)','rgb(137,176,227)',
                                    'rgb(247,106,105)','rgb(60,187,187)','rgb(165,218,84)','rgb(165,218,180)'
                                ];//165 200 72 252
                                return colorList[params.dataIndex]
                            },
                    },
                    label:false,
                    data: [             
                        { value: 34, name: 'Antenatal depressive disorder' },
                        { value: 6929, name: 'CMS model' },
                        { value: 927, name: 'CRS model' },
                        { value: 1829, name: 'Depression' },
                        { value: 179, name: 'Depression with comorbidity' },
                        { value: 22, name: 'Depression with suicide' },
                        { value: 403, name: 'Depressive symptom' },
                        { value: 297, name: 'Depressive symptom with comorbidity' },
                        { value: 44, name: 'Geriatric depression' },
                        { value: 1514, name: 'Healthy individuals' },
                        { value: 79, name: 'LH model' },
                        { value: 562, name: 'LPS induced depression model' },
                        { value: 3710, name: 'Other animal model' },
                        { value: 136, name: 'Pediatric depression' },
                        { value: 85, name: 'Post-stroke depression' },
                        { value: 1, name: 'Postmenopausal depression' },
                        { value: 48, name: 'Postpartum depression' },
                        { value: 955, name: 'Social defeat model' },
                        { value: 285, name: 'Treatment-resistant depression' }
                    ],
                    avoidLabelOverlap: false,
                },
                // {
                //     type: 'pie',
                //     radius: [30,80],
                //     center: ['30%', '33%'],
                
                //     title:'Down',
                //     itemStyle: {
                //         borderRadius: 8,
                //             color: function (params) {
                //                 // build a color map as your need.
                //                 var colorList = [
                //                     'rgb(200,150,255)','rgb(240,151,0)','rgb(251,241,123)','rgb(130,204,232)','rgb(167,213,193)',
                //                     'rgb(255,205,67)','rgb(72,157,240)','rgb(238,102,102)','rgb(221,235,164)','rgb(252,132,82)',
                //                     'rgb(244,136,184)','rgb(10,185,155)','rgb(239,89,160)','rgb(242,204,185)','rgb(137,176,227)',
                //                     'rgb(247,106,105)','rgb(60,187,187)','rgb(165,218,84)'
                //                     // 'rgb(245,250,50)','rgb(249,231,18)','rgb(250,189,5)','rgb(252,153,4)','rgb(255,83,9)','rgb(255,37,19)',//yellow->red
                //                     //  'rgb(193,38,113)','rgb(178,45,190)','rgb(126,72,252)','rgb(81,110,253)','rgb(62,160,240)','rgb(60,187,187)',//purplr blue
                //                     // 'rgb(60,177,40)','rgb(120,200,80)','rgb(165,220,88)','rgb(211,232,50)',//green
                //                 ];
                //                 return colorList[params.dataIndex]
                //             },
                //     },
                //     label:false,
                //     data: [
                //         { value: 34, name: 'Treatment-resistant depression' },
                //         { value: 114, name: 'SDS model' },
                //         { value: 29, name: 'Post-stroke depression' },
                //         { value: 15, name: 'Postpartum depression' },
                //         { value: 5, name: 'Postmenopausal depression' },
                //         { value: 40, name: 'Pediatric depression' },
                //         { value: 284, name: 'Other animal model' },
                //         { value: 77, name: 'LPS induced depression model' },
                //         { value: 31, name: 'LH model' },
                //         { value: 402, name: 'Healthy individuals' },
                //         { value: 21, name: 'Geriatric depression' },
                //         { value: 1, name: 'Depressive symptom with comorbidity' },
                //         { value: 39, name: 'Depressive symptom' },
                //         { value: 11, name: 'Depression with suicide' },
                //         { value: 36, name: 'Depression with comorbidity' },
                //         { value: 399, name: 'Depression' },
                //         { value: 74, name: 'CRS model' },
                //         { value: 975, name: 'CMS model' },
                //         ]
                //     }
            ]
            };
            const optionProtein = {
                legend: {
                    top: 'bottom',
                    left:"10%"
                },
                tooltip: {
                    trigger: 'item',
                    formatter:function(p){
                            if (!p.value && p.value !== 0) return 0;
                            let str = p.value.toString();
                            let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
                            return p.name+" : "+str.replace(reg, "$1,")+" ("+p.percent+"%)";
                        },
                },
                title: [
                    {
                        text: 'Categories',
                        left: '10%',
                        top: '0%',
                        textAlign: 'left',
                        textStyle: {
                            "fontSize": 15
                        }
                    },
                ],
                series: [
                {
                    type: 'pie',
                    radius: [30,80],
                    center: ['50%', '22%'],
                    // roseType: 'area',
                    itemStyle: {
                        borderRadius: 8,
                            color: function (params) {
                                // build a color map as your need.
                                var colorList = [
                                    'rgb(200,150,255)','rgb(240,151,0)','rgb(251,241,123)','rgb(130,204,232)','rgb(167,213,193)',
                                    'rgb(255,205,67)','rgb(72,157,240)','rgb(238,102,102)','rgb(221,235,164)','rgb(252,132,82)',
                                    'rgb(244,136,184)','rgb(10,185,155)','rgb(239,89,160)','rgb(242,204,185)','rgb(137,176,227)',
                                    'rgb(247,106,105)','rgb(60,187,187)','rgb(165,218,84)','rgb(165,218,180)'
                                ];//165 200 72 252
                                return colorList[params.dataIndex]
                            },
                    },
                    label:false,
                    data: [             
                        { value: 5442, name: 'Chronic mild stress model' },
                        { value: 152, name: 'Chronic restraint stress model' },
                        { value: 2508, name: 'Depression' },
                        { value: 17, name: 'Depression with comorbidity' },
                        { value: 45, name: 'Depression with suicide' },
                        { value: 20, name: 'Depressive symptom' },
                        { value: 125, name: 'Depressive symptom with comorbidity' },
                        { value: 96, name: 'Geriatric depression' },
                        { value: 2000, name: 'Healthy individuals' },
                        { value: 63, name: 'LH model' },
                        { value: 213, name: 'LPS induced depression model' },
                        { value: 5875, name: 'Other animal model' },
                        { value: 13, name: 'Post-stroke depression' },
                        { value: 2852, name: 'Social defeat model' },
                        { value: 22, name: 'Treatment-resistant depression' }
                    ],
                    avoidLabelOverlap: false,
                },
            ]
            };
            if(this.type=='metabolite')this.option=optionMetabolite;
            else this.option=optionProtein;
            this.barCirChart.setOption(this.option);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                this.barCirChart.resize();
            });
        },
   }
})


</script>